export * from './get-group-permissions.action';
